<app-dfp-panel
  title="Demonstração do Fluxo de Caixa"
  [titleNote]="scaleTitleNote"
  [collapsible]="collapsible"
  [collapsed]="false"
  [collapseCommand]="collapseCommand">
  <ng-container panelActions>
    @if (allowExport) {
      <app-button
        icon="pi pi-download"
        [pureIcon]="true"
        [text]="true"
        title="Exportar"
        (sendClick)="exportMenu.toggle($event)" />
      <p-menu #exportMenu [popup]="true" [model]="exportMenuItems" [appendTo]="'body'" />
    }
  </ng-container>

  <div class="performance-table performance-table--cash-flow" appDfpClipGuard>
    <p-table [value]="rows" [tableStyle]="{ 'min-width': '100%' }">
      <ng-template pTemplate="header">
        <tr>
          <th appDfpColumnWidth="cash-flow:name">Conta</th>
          @for (year of uniqueYears; track year; let last = $last; let i = $index) {
            <th
              [appDfpColumnWidth]="'cash-flow:' + year"
              [class.is-latest]="last"
              [class.is-zebra]="i % 2 === 1">
              {{ year }}
            </th>
          }
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row>
        <tr [class.is-total]="row.isTotal">
          <!-- Ícone com a memória de cálculo da linha (PBI 3875); some quando nenhuma coluna traz `calculation`. -->
          <td class="nowrap">
            {{ row.name }}
            <app-dfp-calculation-info
              [name]="row.name"
              [columns]="calculationColumnsFor(row)"
              [formatPart]="formatMoneyPart" />
          </td>
          @for (year of uniqueYears; track year; let last = $last; let i = $index) {
            <td [class.is-zebra]="i % 2 === 1" [class.is-latest]="last">
              {{ formatValue(row.values.get(year) ?? 0) }}
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
</app-dfp-panel>
